module.exports = __webpack_public_path__ + "img/BIT_white30.8dc1c832.jpg";